import { render, staticRenderFns } from "./popBox.vue?vue&type=template&id=39def79d&scoped=true&"
import script from "./popBox.vue?vue&type=script&lang=js&"
export * from "./popBox.vue?vue&type=script&lang=js&"
import style0 from "./popBox.vue?vue&type=style&index=0&id=39def79d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39def79d",
  null
  
)

export default component.exports